import { makeStyles } from '@material-ui/core/styles';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import {
  FacebookShareButton,
  GooglePlusShareButton,
  LinkedinShareButton,
  TwitterShareButton
} from 'react-share';

const useStyles = makeStyles(theme => ({
  postSocial: {
    position: 'fixed',
    left: 0,
    top: '50%',
    zIndex: 100,
    transform: 'translateY(-50%)'
  },
  button: {
    display: 'block',
    width: 40,
    height: 40,
    '&:first-of-type span': {
      borderTopRightRadius: theme.shape.borderRadius
    },
    '&:last-of-type span': {
      borderBottomRightRadius: theme.shape.borderRadius
    }
  },
  buttonCtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40
  },
  facebook: {
    backgroundColor: '#3F51B5'
  },
  linkedin: {
    backgroundColor: '#1a7baa'
  },
  twitter: {
    backgroundColor: '#03A9F4'
  }
}));

const Share = ({ socialConfig }) => {
  const classes = useStyles();

  return (
    <div className={classes.postSocial}>
      <FacebookShareButton
        url={socialConfig.config.url}
        className={classes.button}
      >
        <span className={clsx(classes.buttonCtn, classes.facebook)}>
          <FacebookIcon style={{ color: 'white' }} />
        </span>
      </FacebookShareButton>
      <TwitterShareButton
        url={socialConfig.config.url}
        className={classes.button}
        title={socialConfig.config.title}
        via={socialConfig.twitterHandle.split('@').join('')}
      >
        <span className={clsx(classes.buttonCtn, classes.twitter)}>
          <TwitterIcon style={{ color: 'white' }} />
        </span>
      </TwitterShareButton>
      <LinkedinShareButton
        url={socialConfig.config.url}
        className={classes.button}
        title={socialConfig.config.title}
      >
        <span className={clsx(classes.buttonCtn, classes.linkedin)}>
          <LinkedInIcon style={{ color: 'white' }} />
        </span>
      </LinkedinShareButton>
    </div>
  );
};

Share.propTypes = {
  socialConfig: PropTypes.shape({
    twitterHandle: PropTypes.string.isRequired,
    config: PropTypes.shape({
      url: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    })
  }).isRequired
};

export default Share;
